import { Controller } from "@hotwired/stimulus"

// Expand/collapse for the sidebar's global Inbox group, remembered somewhere the
// SERVER can read — the same first-paint contract project-disclosure has.
//
// The cookie is a single 1/0 rather than a list of ids, because there is one
// Inbox group. Default open lives on the server (a missing cookie); this writes
// "0" when the viewer closes it and "1" when they open it again.
//
// The DOM is the truth and the cookie is its mirror.

const COOKIE_MAX_AGE_SECONDS = 31536000

export default class extends Controller {
  static targets = ["children", "toggle"]
  static values = { cookie: String }

  toggle() {
    const open = this.childrenTarget.hidden

    this.childrenTarget.hidden = !open
    this.element.classList.toggle("is-open", open)
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", open ? "true" : "false")

    this.#persist(open)

    if (open) this.childrenTarget.scrollIntoView({ block: "nearest", behavior: "instant" })
  }

  #persist(open) {
    const secure = location.protocol === "https:" ? "; Secure" : ""

    document.cookie =
      `${this.cookieValue}=${open ? "1" : "0"}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`
  }
}
